import { useEffect, useState } from 'react';
import { FoldedCollection, FoldedResultList, FoldedResultListState } from '@coveo/headless';
import { useCoveoSearchEngine } from '../CoveoSearchEngine';
import { useResultTemplates } from './ResultTemplates/ResultTemplates';
import { useUserData } from 'Foundation/User/UserContext';
import { Button } from '@lmig/lmds-react-button';
//import { useNavigate } from 'react-router';
import { Heading } from '@lmig/lmds-react-typography';
import { redirectTo } from 'Utilities/NavigationHelper';

interface IResultListFoldedProps {
  resultList: React.MutableRefObject<FoldedResultList>;
  show: boolean;
}
export function ResultListFolded({ resultList, show }: IResultListFoldedProps) {
  const { userData } = useUserData();
  const { headlessEngine } = useCoveoSearchEngine();
  const { templateManager } = useResultTemplates();
  //let navigate = useNavigate();
  const [resultListState, setResultListState] = useState<FoldedResultListState>(resultList.current.state);
  useEffect(() => {
    const unsub = resultList.current.subscribe(() => {
      setResultListState(resultList.current.state);
    });
    return function cleanup() {
      unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchCustomers = () => {
    let searchTerm = headlessEngine?.state.query?.q;
    /* TODO: update to use client side routing. Reload the whole page for now in case we have to roll back */
    if (searchTerm)
      redirectTo(`/mywork/mywork?command=LoadCustomerAsSearch&type=glb&keyword=${searchTerm}`);
    //navigate(`/mywork/mywork?command=LoadCustomerAsSearch&type=glb&keyword=${searchTerm}`);
    else redirectTo('/mywork/mywork');
    //navigate('/mywork/mywork')
  };

  if (!resultListState?.results.length) {
    return (
      <>
        {show ? (
          <>
            <div className="lm-h1 search-page-section">No Results Found.</div>
            <div className="lm-h4 search-page-section-large-padding search-page-divider">
              We couldn't find any results for "{headlessEngine?.state.search.queryExecuted}".
            </div>
            <div className="search-page-section-large-padding">
              Check your search for any spelling errors, or try searching again using different words.
            </div>
            {userData?.isPL() ? (
              <div>
                <Heading type="h4-bold">Are you looking for a customer?</Heading>{' '}
                <Button style={{ marginLeft: '0' }} onClick={() => searchCustomers()}>
                  Search Customers
                </Button>
              </div>
            ) : (
              <div>
                <b>Are you looking for a customer?</b> If so, go to the left rail, click Customer and policy search for
                the customers search tool.
              </div>
            )}
          </>
        ) : (
          <></>
        )}
      </>
    );
  }

  return (
    <div className="result-folding" role="list" aria-live="polite">
      {resultListState.results.map((collection: FoldedCollection) => {
        const template: any = templateManager.selectTemplate(collection.result);
        return template(collection);
      })}
    </div>
  );
}
